import React from 'react'
import PropTypes from 'prop-types'
import { useField } from 'formik'
import { Box } from 'reflexbox/styled-components'

import { HiddenCheckbox, StyledCheckbox } from './styles'

const Checkbox = ({ label, ...props }) => {
  const [field] = useField(props)

  if (props.selectedValues !== undefined) field.value = props.selectedValues.packages

  const checked = !props.multiple ? field.value : field.value.includes(props.value)

  return (
    <Box mr='24px' mb='8px' display='inline-flex' alignItems='center' as='label' {...props}>
      <HiddenCheckbox checked={checked} {...field} {...props} />

      <StyledCheckbox checked={checked}>
        <CheckIcon />
      </StyledCheckbox>
      {label}
    </Box>
  )
}

Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  selectedValues: PropTypes.object,
}

const CheckIcon = () => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none'>
    <path
      d='M8.73116 12.646L13.3012 6.64603V6.61603C13.3813 6.51097 13.4399 6.39117 13.4737 6.26345C13.5075 6.13574 13.5158 6.00261 13.4982 5.87168C13.4805 5.74075 13.4373 5.61458 13.3709 5.50037C13.3045 5.38615 13.2162 5.28614 13.1112 5.20603C13.0061 5.12593 12.8863 5.0673 12.7586 5.03349C12.6309 4.99969 12.4977 4.99137 12.3668 5.00901C12.2359 5.02665 12.1097 5.06991 11.9955 5.13632C11.8813 5.20272 11.7813 5.29097 11.7012 5.39603L7.92116 10.396L6.29116 8.31603C6.2104 8.21229 6.10999 8.12547 5.99568 8.06053C5.88136 7.99559 5.75537 7.9538 5.62491 7.93755C5.36142 7.90473 5.09568 7.97792 4.88616 8.14103C4.78242 8.22179 4.6956 8.3222 4.63066 8.43652C4.56572 8.55083 4.52393 8.67682 4.50768 8.80729C4.49143 8.93775 4.50103 9.07014 4.53595 9.1969C4.57086 9.32365 4.6304 9.44229 4.71116 9.54603L7.15116 12.656C7.24533 12.7752 7.36542 12.8714 7.5023 12.9372C7.63919 13.0031 7.78927 13.0368 7.94116 13.036C8.09388 13.0357 8.24449 13.0003 8.38143 12.9327C8.51837 12.8651 8.638 12.767 8.73116 12.646Z'
      fill='#FFF'
    />
  </svg>
)

export default Checkbox
